// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8054eee3","239":"6c93c5e9","455":"14fa4e56","488":"b7aa7eba"}[chunkId] + ".chunk.js";
};